import { render, staticRenderFns } from "./CadastroServicosCobranca.vue?vue&type=template&id=5202b648&"
import script from "./CadastroServicosCobranca.vue?vue&type=script&lang=js&"
export * from "./CadastroServicosCobranca.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports